const routes = [
  {
    index: true,
    label: 'HOME',
    path: '/',
  },
  // {
  //   label: 'About',
  //   path: '/about',
  // },
  {
    label: 'RESUME',
    path: '/resume',
  },
  {
    label: 'POSTERS',
    path: '/posters',
  },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: 'IMGS',
    path: '/imgs',
  },
  {
    label: 'CONTACT',
    path: '/contact',
  },
];

export default routes;
